import React from "react";

function ViewOnlyBanner({ fyValue }) {
  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "10px 16px",
      borderRadius: 10,
      background: "#fffbeb",
      border: "1px solid #fcd34d",
      marginBottom: 12,
    }}>
      <span style={{ fontSize: 16 }}>🔒</span>
      <div>
        <span style={{ fontSize: 12, fontWeight: 700, color: "#92400e" }}>
          View Only — {fyValue}
        </span>
        <span style={{ fontSize: 11, color: "#b45309", marginLeft: 8 }}>
          Settings for past financial years cannot be modified.
        </span>
      </div>
    </div>
  );
}

export default ViewOnlyBanner;
